import { render, staticRenderFns } from "./active-filter-list-item.vue?vue&type=template&id=439c1d95"
import script from "./active-filter-list-item.vue?vue&type=script&lang=js"
export * from "./active-filter-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports